import React, { useEffect, useState } from 'react';
import signUpFabPcImg from '@/assets/float_bt/pc/ribon_pc.png';
import signUpFabSpImg from '@/assets/float_bt/sp/ribon_sp.png';
import signUpFabXPcImg from '@/assets/float_bt/pc/bt_pc.png';
import signUpFabXSpImg from '@/assets/float_bt/sp/bt_sp.png';
import { useNavigate } from 'react-router-dom';
import ReactGA from 'react-ga4';

export const SignUpFab = () => {
  const [showBtn, setShowBtn] = useState<boolean>(true);
  const nav = useNavigate();

  useEffect(() => {
    const closedTime = localStorage.getItem('signUpFabClosedTime');
    if (closedTime) {
      const reloadTime = new Date(parseInt(closedTime, 10));
      if (new Date() < reloadTime) {
        setShowBtn(false);
        return;
      }
    }
    setShowBtn(true);
  }, []);

  const evFabXClick = (e: React.MouseEvent<HTMLDivElement>) => {
    e.stopPropagation();
    setShowBtn(false);
    const reloadTime = new Date(Date.now() + 72 * 60 * 60 * 1000);
    localStorage.setItem('signUpFabClosedTime', reloadTime.getTime().toString());
  };

  const evFabClick = () => {
    // GAクリックイベント送信
    ReactGA.gtag('event', 'click_banner', {
      action: 'click',
      event_category: 'click_banner',
      event_label: '会員登録フロート'
    });
    nav('/regist/member_info');
  };

  return (
    <>
      {showBtn && (
        <div
          className="fixed bottom-[24px] md:bottom-[180px] right-[20px] cursor-pointer z-30"
          onClick={evFabClick}
          data-value="fab"
        >
          <img src={signUpFabSpImg} className="block md:hidden w-full h-auto" alt="SignUpSp" />
          <img src={signUpFabPcImg} className="hidden md:block w-full max-w-[204px] h-auto" alt="SignUpPC" />
          <div className="absolute top-[-7px] right-[-7px] cursor-pointer" onClick={evFabXClick} data-value="fabX">
            <img src={signUpFabXSpImg} className="block md:hidden w-full h-auto" alt="SignUpXSp" />
            <img src={signUpFabXPcImg} className="hidden md:block w-full max-w-[35px] h-auto" alt="SignUpXPc" />
          </div>
        </div>
      )}
    </>
  );
};

export default SignUpFab;
